<template>
  <div>
    <BreadCrumb class="bread" :breads="['分级管理', '分级设置']"></BreadCrumb>
    <div class="wrap">
      <div class="header">
        <span class="nameFt">分级设置</span>
      </div>
    </div>
    <div class="submit-form">
      <el-form :model="search" :inline="true" size="small" label-width="80px">
        <!-- <div class="submit-form__search">
          <el-form-item label="名称">
            <el-input v-model="search.name" maxlength="20"></el-input>
          </el-form-item>
        </div> -->
        <!-- <div class="submit-form__operate">
          <el-form-item>
            <el-button class="queryBtn" size="small" type="primary" @click="getList">查询</el-button>
            <el-button class="queryBtn" size="small" type="primary" @click="reset">重置</el-button>
          </el-form-item>
        </div> -->
      </el-form>
    </div>
    <div class="operate-con">
      <el-button size="small" @click="openView('add')">新增</el-button>
    </div>
    <div class="table-con">
      <el-table
        :data="tableList"
        stripe
        v-loading="loading"
        size="small"
        style="width: 100%"
        row-key="id"
        :tree-props="{ children: 'children' }"
        border
        default-expand-all
      >
        <el-table-column
          label="序号"
          align="center"
          type="index"
          width="70"
        ></el-table-column>
        <el-table-column label="名称" prop="name"></el-table-column>
        <el-table-column
          label="层级"
          align="center"
          prop="level"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <div slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              @click="setPermission(scope.row.id)"
              >权限配置</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="openView('addJunior', scope.row)"
              :disabled="scope.row.operation_level"
              >新增下级</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="openView('view', scope.row)"
              >查看</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="openView('update', scope.row)"
              >修改</el-button
            >
            <el-button
              type="danger"
              size="small"
              @click="deleteData(scope.row.id)"
              >删除</el-button
            >
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div class="paginationWrap">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :current-page="pageNum"
        :layout="pageLayout"
        :total="total"
      ></el-pagination>
    </div>
    <!--新增/修改-->
    <el-dialog
      class="dialogMY"
      :visible.sync="showDialog"
      width="450px"
      center
      @closed="handleClose"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="名称" prop="name">
          <el-input
            class="customIpt"
            v-model="ruleForm.name"
            size="small"
            placeholder="请输入名称"
            maxlength="20"
            :disabled="operateType == 'view'"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="上级名称"
          prop="superior_name"
          v-if="operateType == 'addJunior'"
        >
          <el-input
            class="customIpt"
            v-model="ruleForm.superior_name"
            size="small"
            maxlength="20"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="最终运营级" prop="operation_level">
          <el-radio
            v-model="ruleForm.operation_level"
            :label="true"
            :disabled="operateType == 'view' || operateType == 'update'"
            >是</el-radio
          >
          <el-radio
            v-model="ruleForm.operation_level"
            :label="false"
            :disabled="operateType == 'view' || operateType == 'update'"
            >否</el-radio
          >
        </el-form-item>
        <div class="footer">
          <el-button @click="showDialog = false">取 消</el-button>
          <el-button
            @click="confirm(operateType, ruleForm)"
            type="primary"
            v-if="operateType != 'view'"
            >确 定</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <!--删除-->
    <el-dialog
      class="dialogMY"
      :visible.sync="removeDialog"
      width="400px"
      center
    >
      <div slot="title">
        <i class="el-icon-warning"></i>
      </div>
      <div class="Main">
        <div class="infoOne">确定要删除吗？</div>
        <div class="infoTwo">你将无法恢复这条数据！</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="removeDialog = false">取 消</el-button>
        <el-button type="danger" @click="remove()">删 除</el-button>
      </span>
    </el-dialog>
    <!-- 权限配置 -->
    <el-dialog
      class="dialogMY"
      :visible.sync="permissionDialog"
      width="600px"
      center
      @closed="handleCloseConfig"
    >
      <div slot="title">运营端权限配置</div>
      <template>
        <el-tabs
          v-model="activeName"
          :tab-click="handleClick"
          v-if="isPhone !== 0"
        >
          <el-tab-pane label="移动端" name="移动端">
            <phone
              :pageInfo="phoneList"
              :permission="permission"
              :type="isPhone"
              ref="phone"
            />
          </el-tab-pane>
          <el-tab-pane label="PC端" name="PC端">
            <!-- 两个组件的ref 不能一样 -->
            <!-- pageInfo 定义的是全部权限列表， permission是已有的权限列表， 要传各自的对应的数据 -->
            <pc
              :pageInfo="pcList"
              :permission="pc_permissionArr"
              :type="isPhone"
              ref="pcPermission"
            />
          </el-tab-pane>
        </el-tabs>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmPermission(pc_permission)"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import apis from "@/config/apis";
import listMixin from "@/mixins/list";
import phone from "./components/gradeSetting/phone.vue";
import Pc from "./components/gradeSetting/pc.vue";
export default {
  name: "shoppingCategory",
  data() {
    var validateName = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入名称"));
      }
      if (value.trim().length <= 0) {
        callback(new Error("不允许输入空格"));
      }
      let reg = /^[0-9a-zA-Z_\u4e00-\u9fa5]{1,}$/;
      if (!reg.test(value)) {
        callback(new Error("请输入中文、字母、数字、下划线、字符"));
      }
      callback();
    };
    return {
      // checkedAll: false,
      // checkedItem: [],
      checkedAttr: [],
      activeName: "移动端",
      radio: "1",
      operateType: "",
      search: {
        // name: '',
        level: 1,
      },
      showDialog: false,
      modifyshowDialog: false,
      removeDialog: false,
      removeId: "",
      ruleForm: {
        name: "",
        superior: "",
        superior_name: "",
        operation_level: false,
        level: "",
      },
      rules: {
        name: [
          {
            required: true,
            validator: validateName,
            trigger: "change",
          },
        ],
      },
      permissionDialog: false,
      phoneList: [],
      pcList: [],
      pc_permissionArr: [],
      permission: [],
      isPhone: 0,
      hierarchy_id: null,
    };
  },
  mixins: [listMixin],
  components: {
    BreadCrumb,
    phone,
    Pc,
  },
  created() {
    this.getList();
    this.getPhoneConfig();
    this.getPcConfig();
  },
  watch: {
    // 监听复选框是否选中
    // checkedItem() {
    //   if (this.checkedItem.length == this.checkedAttr.length) {
    //     this.checkedAll = true;
    //   } else {
    //     this.checkedAll = false;
    //   }
    // },
  },
  methods: {
    // 全选复选框状态改变监听事件
    // changeAllChecked() {
    //   // console.log(this.checkedItem);
    //   if (this.checkedAll) {
    //     this.checkedItem = this.checkedAttr;
    //   } else {
    //     this.checkedItem = [];
    //   }
    // },
    // 获取移动端配置
    getPhoneConfig() {
      this.$axios.get(apis.apple_power).then((res) => {
        console.log(res);
        const { status, data } = res;
        if (status === 200) {
          if (data.code === 200) {
            this.phoneList = data.data;
          }
        }
      });
    },
    // 获取pc端配置
    getPcConfig() {
      this.$axios.get(apis.pc_power).then((res) => {
        console.log(res);
        const { status, data } = res;
        if (status === 200) {
          if (data.code === 200) {
            this.pcList = data.data;
          }
        }
      });
    },
    handleClick(tab, name) {
      // console.log(tab.$options.propsData.label);
      //  let permission = this.$refs.phone.getAllCheck(); // 获取移动端配置的权限

      // 切换标签的时候保存当前页签的数据
      if (tab === "移动端") {
        this.isPhone = 1;
        let pc_permission = this.$refs.pcPermission.getAllCheck(); // 获取pc配置的权限
        console.log(pc_permission);
        this.pc_permissionArr = pc_permission;
      } else if (tab === "PC端") {
        this.isPhone = 2;
        let permission = this.$refs.phone.getAllCheck(); // 获取移动端配置的权限
        console.log(permission);
        this.permission = permission;
        console.log(this.pc_permissionArr);
      } else {
        console.log("出错了");
      }
    },
    getList() {
      this.getTableData(apis.hierarchy, "get", this.search);
    },
    reset() {
      this.search = {
        // name: '',
        level: 1,
      };
      this.search.page_index = 1;
      this.getList();
    },
    handleClose() {
      this.$refs.ruleForm.resetFields();
      this.ruleForm = {
        name: "",
        superior: "",
        superior_name: "",
        operation_level: false,
        level: "",
      };
    },
    openView(type, row) {
      this.operateType = type;
      if (type == "addJunior") {
        this.ruleForm.superior_name = row.name;
        this.ruleForm.superior = row.id;
        this.ruleForm.level = row.level + 1;
        this.showDialog = true;
      } else if (type == "add") {
        this.showDialog = true;
      } else {
        this.$axios.get(`${apis.hierarchy}/${row.id}`).then((res) => {
          this.ruleForm = res.data.data;
          this.showDialog = true;
        });
      }
    },
    confirm(type, data) {
      if (type == "update") {
        let _data = {
          name: data.name,
          operation_level: data.operation_level,
        };
        this.$axios.put(`${apis.hierarchy}/${data.id}`, _data).then((res) => {
          if (res.data.code == 200) {
            this.$message.success("修改成功");
            this.showDialog = false;
            this.getList();
          } else {
            this.showDialog = false;
            this.$message.error(res.data.msg);
          }
        });
      } else if (type == "addJunior") {
        let _data = {
          level: data.level,
          name: data.name,
          operation_level: data.operation_level,
          superior: data.superior,
        };
        this.$axios.post(apis.hierarchy_save, _data).then((res) => {
          if (res.data.code == 200) {
            this.$message.success("新增成功");
            this.showDialog = false;
            this.getList();
          } else {
            this.$message.error(res.data.msg);
            this.showDialog = false;
          }
        });
      } else {
        let _data = {
          level: 1,
          name: data.name,
          operation_level: data.operation_level,
        };
        this.$axios
          .post(apis.hierarchy_save, _data)
          .then((res) => {
            if (res.data.code == 200) {
              this.$message.success("新增成功");
              this.showDialog = false;
              this.getList();
            } else {
              this.$message.error(res.data.msg);
              this.showDialog = false;
            }
          })
          .catch(() => {
            this.showDialog = false;
          });
      }
    },
    // 权限配置
    setPermission(id) {
      console.log(id);
      this.hierarchy_id = id;
      // 点击权限配置 获取当前行已有的权限配置
      this.$axios
        .get(apis.hierarchy_add_power, {
          params: { hierarchy_id: id },
        })
        .then((res) => {
          const { status, data } = res;
          if (status === 200) {
            if (data.code === 200) {
              this.permissionDialog = true;
              // 获取到pc和移动端已有的配置
              this.pc_permissionArr = data.data.pc_permission;
              this.permission = data.data.permission;
              this.isPhone = 1;
            }
          }
        });
    },
    handleCloseConfig() {
      this.isPhone = 0;
      this.permission = [];
      this.pc_permissionArr = [];
      this.permissionDialog = false;
    },
    // 确定按钮
    confirmPermission(id) {
      console.log(id);
      // 获取了移动端 需要在获取pc的
      let permission = this.$refs.phone.getAllCheck(); // 获取移动端配置的权限
      let pc_permission = this.$refs.pcPermission.getAllCheck(); // 获取pc配置的权限
      // console.log(permission)
      let _data = {
        hierarchy_id: this.hierarchy_id,
        pc_permission,
        permission,
      };
      this.$axios.post(apis.hierarchy_add_power, _data).then((res) => {
        console.log("00", res);
        this.permission = [];
        this.pc_permissionArr = [];
        this.isPhone = 0;
        this.permissionDialog = false;
        // 这里绑定完数据之后调用请求列表的数据接口，解决页面没数据的问题
        this.getList();
      });
    },
    deleteData(id) {
      this.removeDialog = true;
      this.removeId = id;
    },
    remove() {
      let url = `${apis.hierarchy}/${this.removeId}`;
      this.$axios.delete(url).then((data) => {
        let datas = data.data;
        let { code, msg } = datas;
        if (code === 200) {
          this.$message({
            message: msg,
            type: "success",
          });
          this.removeDialog = false;
          this.getList();
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
          this.removeDialog = false;
        }
      });
    },
  },
};
</script>

<style>
.footer {
  display: flex;
  justify-content: center;
}
.customIpt {
  width: 260px;
}
</style>

<style lang="scss" scoped>
/*弹窗*/
.el-icon-warning {
  color: #e6a23c;
  font-size: 60px;
}
.Main {
  text-align: center;
  .infoOne {
    font-size: 28px;
    line-height: normal;
  }
  .infoTwo {
    padding-top: 10px;
    font-size: 14px;
  }
}
</style>
